/**
 * RenderPass that implements rendering some scene object into a back buffer
 */
export class ScenePass {
    constructor(rt, options = {}) {
        this.rt = rt;
        this.clearColor = options.clearColor || false;
        this.clearDepth = options.clearDepth || false;
        this.clearStencil = options.clearStencil || false;
        this.index = options.sceneIndex || 0;
    }
    render(threeRenderer, webGLRenderer, camera, scene) {
        if (typeof scene !== "undefined") {
            webGLRenderer.setRenderTarget(this.rt);
            if (this.clearColor || this.clearDepth || this.clearStencil) {
                webGLRenderer.setClearAlpha(0);
                webGLRenderer.clear(this.clearColor, this.clearDepth, this.clearStencil);
            }
            webGLRenderer.render(scene[this.index], camera);
        }
    }
}
